export interface IRelatedArticle {
    name: string
    synopsis: string
    url: string
    images: IImage[]
    authors: string[]
    sponsor: string
}

interface IImage {
    image: {
        url: string
    }
}

interface IProps {
    article: IRelatedArticle
    single?: boolean
}

const RelatedArticle = ({article, single}: IProps) => {
    let image
    if (article?.images?.length > 0) {
        image = <img className="" src={article.images[0].image.url} />
    }

    let author
    if (article?.authors?.length > 0) {
        author = <div className="pt-[15px] text-[11px] font-normal uppercase leading-[14px] tracking-[0.6px]">By {article.authors[0]}</div>
    }

    let sponsor
    if (article?.sponsor !== undefined && article.sponsor.length > 0) {
        sponsor = (
            <div className="pt-[15px] text-[11px] font-normal uppercase leading-[14px] tracking-[0.6px]">
                Sponsored By <div className="font-semibold">{article.sponsor}</div>
            </div>
        )
    }

    const name = <div className="text-[16px] font-normal leading-[24px] tracking-[-0.2px]">{article?.name}</div>

    if (single) {
        return (
            <div className="bg-white p-[10px]">
                <a href={article?.url} target="site">
                    <div className="grid grid-cols-[177px_auto]">
                        {image}
                        <div className="p-[10px]">
                            {name}
                            {author}
                            {sponsor}
                        </div>
                    </div>
                </a>
            </div>
        )
    }

    return (
        <div className="m-[10px] ml-[5px] mr-[5px] w-[177px] bg-white">
            <a href={article?.url} target="site">
                <div className="">
                    {image}
                    <div className="p-[10px]">
                        {name}
                        {author}
                        {sponsor}
                    </div>
                </div>
            </a>
        </div>
    )
}

export default RelatedArticle
